import countries from "i18n-iso-countries";

/**
 * ISO 9362 (BIC / SWIFT code):
 *  - 4 letters: institution code
 *  - 2 letters: ISO 3166-1 alpha-2 country code
 *  - 2 alphanumerics: location code
 *  - 3 alphanumerics (optional): branch code ("XXX" for the head office)
 */
const BIC_REGEX = /^[A-Z]{4}([A-Z]{2})[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export function isBicValid(input: string): boolean {
    const bic = (input || "").toUpperCase().replace(/\s/g, "");
    const match = bic.match(BIC_REGEX);
    if (!match) {
        return false;
    }
    // the country code must be a real one, "BNPAZZPP" is syntactically valid but does not exist
    return countries.isValid(match[1]);
}
